import React, { FC, useState, useEffect } from 'react';
import classNames from 'classnames';

import { IPropsProductVariant } from './models';
import './ProductVariant.scss';

const ProductVariant: FC<IPropsProductVariant> = ({ productVariant }) => {
  const [activeLink, setActiveLink] = useState<boolean>(false);

  useEffect(() => {
    const currentURL = window.location.href;

    productVariant?.forEach(({ properties: { link } }) => {
      if (currentURL.toLowerCase().includes(link[0].url.toLowerCase())) {
        return setActiveLink(true);
      }
    });
  }, []);

  return (
    <div data-test="ProductVariant" className="product-variant__wrapper">
      {productVariant.map(({ properties: { link, title } }, idx) => (
        <div
          data-test="ProductVariant"
          className={classNames('product-variant', {
            'product-variant--active': activeLink,
          })}
          key={`${link[0].url}-${idx.toString()}`}
        >
          <a href={link[0].url} className="product-variant__link" rel="noreferrer">
            <span className="product-variant__name">{title}</span>
          </a>
        </div>
      ))}
    </div>
  );
};

export default ProductVariant;
